import React, { useState } from 'react';
import { Btn } from 'shared/ui/Btn';
import { LicenseTerms } from './licenseTerms';

type Props = { onAccept: () => void };

/**
 * Tokenised replacement for the classic license agreement component (formerly
 * under src/utils). Same behaviour: the accept button stays disabled until
 * the checkbox is ticked. The terms text itself lives in ./licenseTerms —
 * verbatim legal copy kept in one identifiable module rather than inline here.
 */
export function LicenseScreen({ onAccept }: Props) {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ground/90 p-4 backdrop-blur-sm">
      <div className="max-h-[90vh] max-w-3xl overflow-auto rounded-lg bg-surface p-6">
        <h2 className="mb-4 text-center text-2xl font-bold text-ink">
          VDURA INC. CONFIDENTIAL INFORMATION LICENSE AGREEMENT
        </h2>
        <p className="mb-4 text-center text-ink">
          PLEASE READ THIS AGREEMENT CAREFULLY BEFORE ACCESSING THE PRODUCT CONFIGURATION TOOL
        </p>

        <LicenseTerms />

        <div className="mb-4 flex items-center justify-center">
          <input
            type="checkbox"
            id="agree-checkbox"
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
            className="mr-2"
          />
          <label htmlFor="agree-checkbox" className="text-ink">
            I have read and understand the terms above
          </label>
        </div>

        <div className="flex justify-center">
          <Btn variant="contained" size="lg" disabled={!agreed} onClick={onAccept}>
            I AGREE TO THESE TERMS
          </Btn>
        </div>
      </div>
    </div>
  );
}
